import MainButton from "../MainButton";

function Featured() {
  const services = [
    { label: "Weight Training", time: "Mon–Sat: 5AM–10PM", className: "item-0-div" },
    { label: "Cardio Training", time: "Mon–Sat: 5AM–10PM", className: "item-1-div" },
    { label: "Personal Training", time: "By Appointment", className: "item-2-div" },
    { label: "Strength & Conditioning", time: "Mon–Sat: 5AM–10PM", className: "item-3-div" },
    { label: "Functional Fitness", time: "Mon–Sat: 5AM–10PM", className: "item-4-div" },
    { label: "Body Transformation", time: "Mon–Sat: 5AM–10PM", className: "item-5-div" },
  ];

  return (
    <>
      <section id="featured" className="page-padding py-16 sm:py-24 md:py-28 bg-white">
        <div className="container">
          {/* title */}
          <div className="flex flex-col text-center items-center relative">
            <div className="relative inline-flex items-center justify-center gap-2 bg-[#ff0336] text-white text-[12px] sm:text-[13px] uppercase font-bold tracking-[3px] px-6 py-2 rounded-lg transform -skew-x-12 shadow-lg shadow-[#ff0336]/20">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
              <span>our services</span>
            </div>
            <h2 className="text-[24px] sm:text-[30px] md:text-[36px] text-black font-bold my-6 sm:my-8 max-w-2xl leading-tight">
              We Offer Best Fitness Services For You
            </h2>
          </div>
          {/* grid */}
          <div className="featured-grid mt-4 sm:mt-7">
            {services.map((svc, idx) => (
              <div key={idx} className={`${svc.className} relative rounded-xl overflow-hidden shadow-lg`}>
                <div className={`item-${idx} ease-in duration-[0.4s] p-6`}></div>
                <div className="absolute z-10 bottom-6 left-6 sm:bottom-8 sm:left-8">
                  <p className="text-white text-[22px] sm:text-[26px] md:text-[30px] font-bold drop-shadow-md">{svc.label}</p>
                  <p className="text-white bg-brand-gradient text-[13px] sm:text-[15px] mt-2 py-1 px-4 rounded-md inline-block font-semibold">
                    {svc.time}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* featured cta */}
      <div className="featured-cta flex justify-center text-left items-center md1000:bg-none bg-brand-gradient py-12 sm:py-16">
        <div className="container page-padding">
          <div className="flex items-center md1000:flex-col md1000:gap-8 md1000:text-center justify-between">
            <h2 className="text-white font-bold text-[22px] sm:text-[28px] md:text-[34px] max-w-4xl px-2 sm:px-7 leading-snug">
              WHERE LIMITS BECOME LEGENDS – Start Your Fitness Journey Today!
            </h2>
            <div className="flex-shrink-0">
              <MainButton
                color={`text-black`}
                bg={`bg-white`}
                text="Join With Us"
                arrowColor={`text-black`}
                goTo="/contact"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Featured;
